import { memo } from 'preact/compat';

/**
 * Boundary for controllers that still render complex feature markup imperatively.
 * It is deliberately memoized and receives no props: Preact owns the shell around
 * it but never reconciles controller-owned children inside #content/#section-tabs.
 */
export const SectionTabsHost = memo(function SectionTabsHost() {
  return <nav id="section-tabs" class="section-tabs" aria-label="Подразделы" />;
});

export const RuntimeViewHost = memo(function RuntimeViewHost() {
  return <section id="content" class="content" aria-live="polite" />;
});
